export function getEnv(str) {
    return process.env["VUE_APP_" + str];
}